import { ApplicationType, TdhFormula } from "../../../types/types";
import { calculateTdh } from "./calculateTdh";

export const TDH_FORMULAS: Partial<Record<ApplicationType, TdhFormula>> = {
	sump: calculateTdh,
	septic: calculateTdh,
	sewage: calculateTdh,
};

export function getTdhFormula(
	applicationType: ApplicationType | null,
): TdhFormula | undefined {
	if (!applicationType) {
		return undefined;
	}

	return TDH_FORMULAS[applicationType];
}

export { calculateTdh } from "./calculateTdh";
